



















































import { mapActions, mapGetters } from 'vuex';

import { DataTable, IndexSubmitForm, NoDataFound, UiButton, UiIconButton, UiModal } from '../../components';

import { ApiEnum, DeviceEnum, SortDirectionEnum } from '../../enums';

import { INDEX_CONSTS } from '../../store/index/index.consts';

export default {
  name: 'index-list',
  components: {
    DataTable,
    NoDataFound,
    IndexSubmitForm,
    UiButton,
    UiIconButton,
    UiModal
  },
  computed: {
    ...mapGetters(INDEX_CONSTS.moduleName, {
      jobs: INDEX_CONSTS.getters.jobs
    }),
    data: function () {
      let data = this.jobs;
      if (!!this.sort.field) {
        data = data.sort((job1, job2) => {
          let field1 = 0, field2 = 0;
          if (this.sort.field === 'meta.date') {
            field1 = job1.meta.date;
            field2 = job2.meta.date;
          } else {
            field1 = job1[this.sort.field].toUpperCase();
            field2 = job2[this.sort.field].toUpperCase();
          }
          const comparison = (field1 > field2) ? 1 : ((field1 < field2) ? -1 : 0);
          return SortDirectionEnum.ASCENDING === this.sort.direction ? comparison : comparison * -1;
        });
      }
      return data;
    },
    modalSize: function (): string {
      return this.$epb.device === DeviceEnum.MOBILE ? 'fullscreen' : 'normal';
    }
  },
  data: function () {
    const messages = this.$epb.messages.tools.index;
    return {
      columns: [
        {
          id: 'feedId',
          text: messages.fields.feedId.label,
          sortable: true
        }, {
          id: 'meta.date',
          text: messages.fields.date.label,
          sortable: true
        }, {
          id: 'id',
          text: messages.fields.id.label,
          width: '75%'
        }, {
          id: 'fileId',
          text: messages.fields.fileId.label
        }, {
          id: 'timestamps',
          text: messages.fields.timestamps.label
        },
        {
          id: 'elements',
          text: messages.fields.elements.label
        }, {
          id: 'state',
          text: messages.fields.state.label,
          width: '75%',
          sortable: true
        }
      ],
      submitButtonConfig: {
        color: 'primary',
        icon: 'add'
      },
      messages: messages,
      sort: {},
      DeviceEnum,
      SortDirectionEnum
    };
  },
  props: {
    loading: Object
  },
  methods: {
    ...mapActions(INDEX_CONSTS.moduleName, {
      listJobs: INDEX_CONSTS.actions.listJobs,
      fetchInfo: INDEX_CONSTS.actions.fetchInfo,
      submitJob: INDEX_CONSTS.actions.submitJob
    }),
    loadData: async function () {
      this.$emit('updateLoading', { visible: true });
      try {
        await this.listJobs();
        await this.fetchInfo();
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.INDEX));
      } finally {
        this.$emit('updateLoading', { visible: false });
      }
    },
    onSubmitAccept: async function (job) {
      this.$emit('updateLoading', { visible: true });
      try {
        this.$refs.submitModal.close();
        await this.submitJob({ feedId: job.clientFeedId, file: job.formData });
        this.$refs.submitForm.resetForm();
        await this.loadData();
        this.$emit('showSnackbar', this.messages.submit.success);
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.INDEX));
      } finally {
        this.$emit('updateLoading', { visible: false });
      }
    },
    onSubmitCancel: function (): void {
      this.$refs.submitModal.close();
      this.$refs.submitForm.resetForm();
    },
    getTimesHtml: function (metrics): string {
      if (!!metrics) {
        return `${ this.messages.fields.metrics.read }: <b>${ metrics.readTime }</b> | ${ this.messages.fields.metrics.write }: <b>${ metrics.writeTime }</b> | ${ this.messages.fields.metrics.total }: <b>${ metrics.totalTime }</b>`;
      } else {
        return '';
      }
    },
    getElementsHtml: function (metrics): string {
      if (!!metrics) {
        return `${ this.messages.fields.metrics.read }: <b>${ metrics.readProcessed }</b> | ${ this.messages.fields.metrics.write }: <b>${ metrics.writeProcessed }</b>`;
      } else {
        return '';
      }
    }
  },
  created: function () {
    this.loadData();
  }
};

